export enum ProviderGroupPaymentTier {
  Tier1 = '10',
  Tier2 = '30',
  Tier3 = '45',
}

export const ProviderGroupPaymentTierLabels: Record<ProviderGroupPaymentTier, string> = {
  [ProviderGroupPaymentTier.Tier1]: 'Tier 1',
  [ProviderGroupPaymentTier.Tier2]: 'Tier 2',
  [ProviderGroupPaymentTier.Tier3]: 'Tier 3',
}
